import React, { FC } from 'react';
import './style.scss';
import Icon from '../../icon';
import { iconSize } from '../../../../constants/icon.constants';
import { TNavigationBarItemProps } from './types/navigationBarItem.types';
import RoutableNotEditableLink from '../../routableNotEditableLink';
import { googleNavClickEvent } from '../../../../utils/analytics';
import { breadcrumb } from '../../../../constants/analytics.constants';

const NavigationBarItem: FC<TNavigationBarItemProps> = ({ item, isLast = false, extraClassName = '' }) => {
  if (item?.url?.trim().length === 0) {
    return (
      <>
        {item.text && (
          <li className={`nav-bar__item nav-bar__item--text ${extraClassName}`}>
            <>
              {item.text}
              <Icon iconName="arrow-chevron-right" size={iconSize.dsk} extraClassName="nav-bar__chevron-icon" />
            </>
          </li>
        )}
      </>
    );
  }

  return (
    <>
      {item.text && (
        <li className={`nav-bar__item${isLast ? ' nav-bar__item--last' : ''} ${extraClassName}`}>
          {isLast ? (
            item.text
          ) : (
            <>
              <RoutableNotEditableLink
                className="link"
                href={item.url}
                onClick={() => {
                  googleNavClickEvent(breadcrumb, item?.url, item?.text);
                }}
              >
                {item.text}
              </RoutableNotEditableLink>
              <Icon extraClassName="nav-bar__back-icon" size={iconSize.mbl} iconName="arrow-chevron-right" />
            </>
          )}
        </li>
      )}
    </>
  );
};

export default React.memo(NavigationBarItem);
